import { styled } from "../../../stitches.config";

export const ErrorInput = styled("span", {
    fontSize: 12,
    fontWeight: 300,
    opacity: 0.6,
    color: "$red9",
    userSelect: 'none'
})